import type { IMessageWriter } from '../../../engine/messageWriter'
import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'
import { assert } from '../../../lib/assert-sidecar'
import { voyageCrew } from '../voyageCrew-sidecar'
import { voyageGameManager } from '../voyageGameManager-sidecar'
import { voyageGameMode_game } from '../voyageGameMode_game-sidecar'
import { EVoyageMessage } from './voyageMessageIds'

export interface IMessageHostCommand {
  command: EHostCommand
  crewId?: number
}

export enum EHostCommand {
  Reset = 0,
  DestroyCrew = 1,
}

export const voyageMessageId = EVoyageMessage.HostCommand

export function write(m: IMessageWriter, d: IMessageHostCommand) {
  messageWriter.write8(m, voyageMessageId)
  messageWriter.write8(m, d.command)
  messageWriter.write32(m, d.crewId || 0)
}

export function read(m: IMessageWriter) {
  let t = messageWriter.read8(m)
  assert.eq(t, voyageMessageId)

  let d: IMessageHostCommand = {
    command: messageWriter.read8(m),
    crewId: messageWriter.read32(m),
  }
  return d
}

export function test() {
  let ex: IMessageHostCommand = {
    command: EHostCommand.DestroyCrew,
    crewId: 1234,
  }
  messageWriter.test('host-command', ex, write, read)
}

export function process(m: IMessageWriter) {
  let msg = read(m)

  if (msg.command === EHostCommand.Reset) {
    console.log('!! HOST COMMAND RESET GAME')
    voyageGameMode_game.reset()
  }
  if (msg.command === EHostCommand.DestroyCrew) {
    let cr = voyageCrew.findById(msg.crewId || 0)
    assert.notNil(cr)
    voyageCrew.kill(cr)
  }
}

export function sendMessageAndImmediatelyExecute(msg: IMessageHostCommand) {
  websockets._sendMessageAndImmediatelyExecute(write, msg)
}
